<template>
  <div>
    <div class="head">
      <div class="headbar">
        <div class="container">
          <div class="head-lt">
            <a>欢迎回来到沃德珠宝！</a>
          </div>
          <div class="head-md webCSS">
            <marquee direction="left">
              温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
              1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
              2、实际到货后， 货品“地点”将变更为”HK”。
              3、下单即视为可以接受货品7个工作日之内到港。
              4、货品质量与香港现货库存一致。
            </marquee>
          </div>
        </div>
      </div>
      <div class="head-nav">
        <div class="header">
          <div class="header-lt">
            <div class="logo">
              <a href>
                <img src="/static/img/img/logo.png" />
              </a>
            </div>
          </div>
          <div class="header-ce">
            <div class="nav">
              <ul>
                <li @click="goPage('Home')">首页</li>
                <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                <li @click="goPage('MyCar')">我的购物车</li>
                <li @click="goPage('MyOrder')">我的订单</li>
                <li @click="goPage('Calculator', true)">计算器</li>
                <li @click="goPage('FeedBack', true)">问题反馈</li>
                <li @click="goPage('ChangePass')">修改密码</li>
                <li @click="loginOut">注销登录</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="container-diam">
        <div class="title-box webCSS">
          <span class="title_1">我的购物车</span>
        </div>
        <div class="clear"></div>
        <div class="container-form">
          <div id="wrapper">
            <div id="scroller">
              <div id="tabs" name="diamonds">
                <div id="tblist">
                  <table class="ltable">
                    <thead>
                      <tr>
                        <th>选择</th>
                        <th>货号</th>
                        <th>形状</th>
                        <th>重量</th>
                        <th></th>
                        <th class="style1">颜色</th>
                        <th>净度</th>
                        <th>台深</th>
                        <th>奶色</th>
                        <th>折扣</th>
                        <th>证书</th>
                        <th>证书号</th>
                        <th>切工</th>
                        <th>拋光</th>
                        <th>对称</th>
                        <th>荧光</th>
                        <th>台宽</th>
                        <th>咖色</th>
                        <th></th>
                        <th>价格</th>
                        <th>备注</th>
                      </tr>
                    </thead>
                    <tbody class="tbody" :onAreMore="hasMore">
                        <tr id="row" class="statu_"  v-for="(item, index) in dataList" :key="index" @click="showDetail(item)">
                        <td><div class="MyCar-info-choose" :class="item.selected && 'active'" @click="pushChoice(item)"></div></td>
                        <td>{{item.diamond.d_ref || '-'}}</td>
                        <td>{{item.diamond.cnShape || '-'}}</td>
                        <td>{{item.diamond.d_size || '-'}}ct</td>
                        <td></td>
                        <td>{{item.diamond.color || '-'}}</td>
                        <td>{{item.diamond.clarity || '-'}}</td>
                        <td>{{item.diamond.d_depth || '-'}}mm</td>
                        <td>{{item.diamond.milkyText || '-'}}</td>
                        <td>{{0 - item.diamond.disc}}%</td>
                        <td>{{item.diamond.cert || '-'}}</td>
                        <td>{{item.diamond.certno || '-'}}</td>
                        <td>{{item.diamond.cut || '-'}}</td>
                        <td>{{item.diamond.polish || '-'}}</td>
                        <td>{{item.diamond.sym || '-'}}</td>
                        <td>{{item.diamond.flour || '-'}}</td>
                        <td>{{item.diamond.d_table || '-'}}mm</td>
                        <td>{{item.diamond.brownessText || '-'}}</td>
                        <td></td>
                        <td>{{item.price || '-'}}</td>
                        <td><div class="MyCar-info-out" v-if="item.failure == 0">该钻石已售出或已失效，请重新选购</div></td>
                        </tr>
                      <tr v-if="!dataList.length && options.isOk">
                        <td colspan="25" rowspan="4" style="height: 200px" >
                          <span>购物车暂无商品，快去选购吧.</span>
                        </td>
                      </tr>
                    </tbody>
                    <div class="MyCar-foot box-shadow" slot="footer" v-if="dataList.length">
                        <div class="MyCar-foot-count" v-if="database.choice.length">
                            已选中 <span class="text-price">{{database.choice.length}}</span> 条<br>
                            合计 <span class="text-price">{{totalPrice}}</span> 元
                        </div>
                        <div class="MyCar-foot-button clearfix">
                            <div class="page-head-text" v-if="dataList.length" @click="pushChoiceAll">{{database.choice.length == dataList.length ? '取消' : '全选'}}</div>
                            <button class="MyCar-foot-button-info" @click="removeChoice">删除</button>
                            <button class="MyCar-foot-button-info active" @click="createOrder">确认下单</button>
                        </div>
                    </div>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="board" style="display: none">
      <div class="board_title">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>公告栏
        <span>Notice Board</span>
        <a class="board_close"></a>
      </div>
      <p>
        温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
        2、实际到货后， 货品“地点”将变更为”HK”。
        3、下单即视为可以接受货品7个工作日之内到港。
        4、货品质量与香港现货库存一致。
      </p>
    </div>
    <div class="modelBox" style="display:none;">
      <div class="model">
        <img src />
        <p class="timeer">
          <span>4</span>&nbsp;S
        </p>
        <i class="closed">x</i>
      </div>
    </div>
  </div>
</template>
<script>
import Core from '@/until/core'
import ScrollPullDown from '@/public/ScrollPullDown'
import SideMenu from '@/public/SideMenu'
export default {
  name: 'MyCar',
  data () {
    return {
      options: {
        isOk: false,
        refreshDelay: 0,
        SideMenu: false
      },
      database: {
        paging: {
          uid: 9,
          pagesize: 99,
          pageint: 1,
          totalrecord: 0,
          totalpage: 0
        },
        list: [],
        choice: []
      }
    }
  },
  components: {
    ScrollPullDown,
    SideMenu
  },
  watch: {},
  computed: {
    hasMore () {
      return this.database.paging.totalpage > this.database.paging.pageint
    },
    dataList () {
      const data = this.database.list || []
      const choice = this.database.choice
      const shape = [
        'ROUND',
        'PRINCESS',
        'PEAR',
        'HEART',
        'MARQUISE',
        'OVAL',
        'EMERALD',
        'RADIANT',
        'CUSHION',
        'TRIANGLE'
      ]
      for (let value of data) {
        value.selected = false
        const diamond = JSON.parse(value.people_cart_diamond || '{}')
        value.diamond = diamond
        if (diamond.shape && shape.indexOf(diamond.shape) > -1) {
          value.fullPath =
            '/static/img/' + diamond.shape.toLowerCase() + '.png'
        }
        if (!value.fullPath) {
          value.fullPath = '/static/img/other.png'
        }
        value.price = parseInt(value.people_cart_product_price, 10) || 0
        value.failure = parseInt(value.failure, 10) || 0
        for (let item of choice) {
          if (
            parseInt(value.people_cart_id, 10) ===
            parseInt(item.people_cart_id, 10)
          ) {
            value.selected = true
          }
        }
      }
      return data
    },
    totalPrice () {
      const choice = this.database.choice
      let price = 0
      for (let item of choice) {
        price += parseInt(item.price, 10)
      }
      return price
    },
    cartId () {
      const choice = this.database.choice
      const arr = []
      for (let item of choice) {
        arr.push(parseInt(item.people_cart_id, 10))
      }
      return arr
    },
    uid () {
      return this.$route.params.Uid
    }
  },
  filters: {},
  methods: {
    goPage (name, bool) {
                const that = this
                if (bool) {
                    return Core.goNext(name, that.$route.params)
                }
                Core.loginExist().then(res => {
                    if (res) {
                        return Core.goNext(name, that.$route.params)
                    }
                    Core.goNext('StaffLogin', that.$route.params)
                })
            },
    loginOut () {
                Core.onRemoveToken()
                Core.goNext('StaffLogin', this.$route.params, true)
            },
    goBack () {
      Core.goBack()
    },
    onGetList () {
      const that = this
      that.$store.commit('onChangeAppLoaderShow', true)
      Core('Custommall/Cart/DiamondListing', that.database.paging).then(
        result => {
          that.options.refreshDelay += 1
          that.$store.commit('onChangeAppLoaderShow', false)
          that.options.isOk = true
          const res = result.data || {}
          if (res.error_code || !res.data) {
            return layer.msg(res.error_msg || '系统繁忙', { icon: 0 })
          }
          that.database.paging.totalrecord = parseInt(
            res.data.totalrecord || 0,
            10
          )
          that.database.paging.totalpage = parseInt(
            res.data.totalpage || 0,
            10
          )
          that.database.list = res.data.list
        }
      )
    },
    onPullDown (done) {
      const that = this
      // 下拉加载
      if (!this.hasMore) {
        return layer.msg('已经是最后一页了！')
      }
      if (that.database.paging.totalpage > that.database.paging.pageint) {
        that.database.paging.pageint += 1
        that.onGetList()
      }
      setTimeout(done, 2000)
    },
    pushChoice (item) {
      for (let i = 0; i < this.database.choice.length; i++) {
        if (
          parseInt(item.people_cart_id, 10) ===
          parseInt(this.database.choice[i].people_cart_id, 10)
        ) {
          this.database.choice.splice(i, 1)
          return
        }
      }
      this.database.choice.push(item)
    },
    removeChoice () {
      const that = this
      const choice = that.database.choice
      if (!choice.length) {
        return layer.msg('请先选择要删除的裸钻！', { icon: 0 })
      }
      layer.open({
        title: '提示',
        content: '确定要删除选中吗？',
        btn: ['确定', '取消'],
        yes (index, layero) {
          layer.close(index)
          that.$store.commit('onChangeAppLoaderShow', true)
          function forEach (index) {
            if (index >= choice.length) {
              that.$store.commit('onChangeAppLoaderShow', false)
              that.onGetList()
              return layer.msg('删除成功！', { icon: 1 })
            }
            const param = {}
            param.database = {}
            param.database.diamond_id = choice[index].people_cart_diamond_id
            param.database.cart_product_number =
              0 - choice[index].people_cart_product_number
            Core('Custommall/Cart/DiamondChange', param).then(result => {
              that.$store.commit('onChangeAppLoaderShow', false)
              const res = result.data || {}
              if (res.error_code || !res.data) {
                that.$store.commit('onChangeAppLoaderShow', false)
                return layer.msg(res.error_msg || '系统繁忙', { icon: 0 })
              }
              forEach(index + 1)
            })
          }
          forEach(0)
        },
        btn2 (index, layero) {
          layer.close(index)
        }
      })
    },
    pushChoiceAll () {
      if (this.database.choice.length === this.dataList.length) {
        this.database.choice = []
        return
      }
      this.database.choice = this.dataList
    },
    createOrder () {
      const that = this
      const choice = that.database.choice
      if (!choice.length) {
        return layer.msg('请先选择要下单的裸钻！', { icon: 0 })
      }
      for (let item of choice) {
        if (item.failure === 0) {
          return layer.msg('失效的裸钻无法下单！', { icon: 0 })
        }
      }
      const param = {}
      param.cart_id = that.cartId
      that.$store.commit('onChangeAppLoaderShow', true)
      Core('Custommall/Order/DiamondCartCreate', param).then(result => {
        that.$store.commit('onChangeAppLoaderShow', false)
        const res = result.data || {}
        if (res.error_code || !res.data) {
          return layer.msg(res.error_msg || '系统繁忙', { icon: 0 })
        }
        that.onGetList()
        layer.msg('下单成功！', { icon: 1 })
        Core.goNext('MyOrder', that.$route.params)
      })
    },
    onSideMenu (state) {
      this.options.SideMenu = false
    }
  },
  mounted () {
    const that = this
    that.database.paging.uid = that.$route.params.Uid
    that.onGetList()
  }
}
</script>
<style scoped>
@import '../../node_modules/swiper/dist/css/swiper.min.css';
@import '../../static/css/yellow.css';
@import '../../static/css/font-awesome.css';
@import '../../static/css/default.css';
.nav{ height: 90px; }
.header-ce{ width:1000px; }
.header-ce ul li{ float: left; line-height: 90px; width:100px; text-align: center;}
.Home-banner{ width: 100%; height: 600px; overflow: hidden; background-color: #fff; }
.btn-hk {
            color: #fff;
            padding: 8px 16px;
            line-height: 100px;
            background: #F268A3;
            border-radius: 2px;
            font-size: 13px;
        }

        .modelBox {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(0, 0, 0, .65);
            overflow: hidden;
            z-index: 999;
        }

        .model {
            position: absolute;
            width: 1000px;
            height: 500px;
            margin: 0 auto;
            left: 0;
            right: 0;
            top: calc(50% - 350px);
            z-index: 9999;
            text-align: center;
            padding: 50px 0;
        }

        .closed {
            display: block;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            position: absolute;
            right: 150px;
            top: 120px;
            text-align: center;
            line-height: 22px;
            background: #e0b12f;
            color: #fff;
            font-size: 14px;
            cursor: pointer;

        }

        .timeer {
            text-align: center;
            position: absolute;
            bottom: 0;
            width: 100px;
            margin: auto;
            left: 0;
            right: 0;
            line-height: 40px;
            font-size: 14px;
            color: #FFEB3B;
            font-size: 30px;
            border-radius: 5px;
        }
        .selectall {
          width: 24px;
          height: 24px;
        }
.nav {
  height: 90px;
}
.header-ce {
  width: 1000px;
}
.header-ce ul li {
  float: left;
  line-height: 90px;
  width: 100px;
  text-align: center;
}
.MyCar-main {
  width: 100%;
  height: 600px;
  overflow: auto;
  padding: 30px 0 70px 26px;
}
.MyCar-info {
  width: 100%;
  height: 200px;
  padding-left: 280px;
  position: relative;
  margin-bottom: 30px;
}
.MyCar-info-img {
  position: absolute;
  left: 60px;
  top: 0;
  width: 200px;
  height: 100%;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fbfbfb;
}
.MyCar-info-item {
  width: 100%;
  height: 26px;
  line-height: 26px;
  font-size: 18px;
  overflow: hidden;
}
.MyCar-info-item-info {
  float: left;
  width: 33.333%;
  height: 100%;
  overflow: hidden;
}
.MyCar-info-item-info.left {
  padding-left: 0.2rem;
}
.MyCar-info-item-info.full {
  width: 100%;
}
.MyCar-info-item-info.half {
  width: 50%;
}
.MyCar-info-price {
  position: absolute;
  left: 285px;
  bottom: 0;
  line-height: 50px;
  font-size: 26px;
  color: #ff410f;
}
.MyCar-info-out {
  font-size: 12px;
  color: red;
}
.MyCar-info-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 0.5rem;
  line-height: 0.46rem;
  padding: 0 0.2rem;
  border: 1px solid #ff410f;
  color: #ff410f;
  font-size: 0.26rem;
  border-radius: 0.25rem;
}

.MyCar-foot {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 70px;
  width: 100%;
  margin: 0 auto;
  background-color: #fff;
  z-index: 11;
}
.MyCar-foot-count {
  position: absolute;
  left: 300px;
  top: 0;
  width: 230px;
  height: 100%;
  overflow: hidden;
  padding: 14px 5px 0;
  text-align: center;
  font-size: 18px;
  line-height: 25px;
}
.MyCar-foot-button {
  position: absolute;
  right: 8px;
  top: 24px;
  bottom: 8px;
}
.MyCar-foot-button-info {
  float: left;
  width: 200px;
  border: none;
  margin-left: 20px;
  font-size: 18px;
  outline: 0;
}
.MyCar-foot-button-info.active {
  background-color: #f36ea7;
  color: #fff;
}
/* .MyCar-foot-button-info:last-child {
  margin: 0;
} */
.MyCar-info-choose {
  width: 18px;
  height: 18px;
  margin: 0 auto;
  background: url(../../static/img/radio_icon.png) no-repeat 0 center;
  -webkit-background-size: 18px 18px;
  background-size: 18px 18px;
}
.MyCar-info-choose.active {
  background: url(../../static/img/radio_icon_active.png) no-repeat 0 center;
  -webkit-background-size: 18px 18px;
  background-size: 18px 18px;
}

.MyCar-info-box {
  width: 100%;
}
.page-head-text {
    float: left;
    width: 136px;
    text-align: center;
    height: 27px;
    line-height: 27px;
    border: none;
    font-size: 18px;
    margin-right: 990px;
    background-color: #f1f1f1;
    outline: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/MyCar.vue